import { faBars } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { Collapse } from "react-bootstrap";
import BoomIcon from "../../../assets/icons/boomerang_element-01.svg2";

export default function ProjectProgress() {
  const [show, setShow] = useState(true);

  return (
    <div>
      <button
        type="button"
        onClick={() => setShow(!show)}
        className="btn position-absolute end-0 mt-2"
      >
        <FontAwesomeIcon icon={faBars} />
      </button>
      <Collapse in={show} dimension="width">
        <div>
          <div
            className="mx-0 bg-purple-gradient-darker p-4 rounded-start-3 "
            style={{ width: 400 }}
          >
            <div className="">
              <h4 className="fw-bold">PROJECT PROGRESS</h4>
              <div className="text-secondary small">
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
              </div>
              <hr className="opacity-25" />
              <h5 className="fw-bold mt-4">RECOMMENDATIONS</h5>
              <div className="d-flex">
                <div className="pe-4">
                  <BoomIcon width={30} />
                </div>
                <div>
                  <h6 className="fw-bold small opacity-50">GENERAL</h6>
                  <div className="fw-bold small">
                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  </div>
                  <div className="text-secondary small">
                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  </div>
                </div>
              </div>
              <hr className="opacity-25" />
              <h5 className="fw-bold mt-4">OUTSTANDING ISSUES</h5>
              <div className="text-secondary small">There are no issues.</div>
            </div>
          </div>
        </div>
      </Collapse>
    </div>
  );
}
